/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, elementHasClassName, htmlspecialchars } from './util.js';
import { closeDialog } from './dialog-util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { MVPage_trigger_winresize } from './page-util.js';
import { mjt } from './i18ntexts.js';
import { confirm_box } from './page-modal.js';

import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';
import { MVTrees } from './trees.js';


export let MVBulkPermissions = function($,mj) {

	var m_dlg_id = 'mbulkperms-form',
		m_dlg = null,
		m_table = null,
		m_media_ids = [],
		m_all_actions = [],
		m_users_by_id = {},
		m_groups_by_id = {},
		m_apply_to_group_id = 0,
		m_apply_to_user_id = 0,
		m_dlg_w = function(win_size) {
			var max_w = Math.min( 440+Math.max(m_all_actions.length,1)*148, 6000 );
			return Math.min( Math.max(win_size[0]-16-40,600), max_w );
		},
		m_dlg_h = function(win_size) {
			var max_h = Math.min( 250+Math.max(m_media_ids.length,2)*108, 4000 );
			return Math.min( Math.max(win_size[1]-20-40,290), max_h );
		},
		m_mbp_cell_template = null,
		m_mbp_colr2h_template = null;


	function _destroy_dlg() {
		$(document).off('.MVBulkPermissions');
		if( m_dlg ) {
			$(document).off('mjswinresize.MVBulkPermissions');
			if( m_table ) {
				m_table.fixedHeaderTable('destroy');
				m_table = null;
			}
			m_dlg.find('form').empty();
			closeDialog(m_dlg,true);
			m_dlg = null;
		}
	}

	function _prepare_dlg() {
		_destroy_dlg();
		m_dlg = $('#'+m_dlg_id);
	}

	function _setup_and_show_dlg() {
		m_dlg.dialog( {
			width:m_dlg_w, height:m_dlg_h,
			modal:true, resizable:false,
			close:function(ev,ui) {
				_destroy_dlg();
			},
		} );
		$(document)
			.off('mjswinresize.MVBulkPermissions')
			.on('mjswinresize.MVBulkPermissions', $.debounce( 125, function(evt,w,h) {
				if( m_table ) {
					// resize table..
					var form = m_dlg.find('form'),
						fht_wrapper = m_dlg.find('div.fht-table-wrapper'),
						fht_fixed_body = fht_wrapper.children('div.fht-fixed-body'),
						fht_fixed_body_tbody = fht_fixed_body.children('div.fht-tbody'),
						fht_fixed_body_thead= fht_fixed_body.children('div.fht-thead'),

						fht_fixed_column = fht_wrapper.children('div.fht-fixed-column'),
						fht_fixed_column_tbody = fht_fixed_column.children('div.fht-tbody');

					var fht_w = form.outerWidth(),
						fht_h = form.outerHeight() - fht_fixed_body_thead.outerHeight() - 2;

					fht_fixed_column_tbody.css( { height:(fht_h+2)+'px' } );
					fht_fixed_body.css( { width:(fht_w)+'px' } );
					fht_fixed_body_tbody.css( { height:(fht_h+2)+'px' } );
				}
			} ) );
	}

	function _set_apply_to( str, cb ) {
		if( str==='' ) {
			// empty default selected
			m_apply_to_group_id = 0;
			m_apply_to_user_id = 0;
		} else if( str.substring(0,5)=='user.' ) {
			m_apply_to_group_id = 0;
			m_apply_to_user_id = str.substring(5);
		} else if( str.substring(0,6)=='group.' ) {
			m_apply_to_group_id = str.substring(6);
			m_apply_to_user_id = 0;
		}
		if( cb ) cb();
	}

	function _get_apply_to_text( xobj ) {
		var apply_to_text = '(unknown)';
		if( xobj.hasOwnProperty('apply_to') && xobj.apply_to.length==2 ) {
			var xid = xobj.apply_to[1];
			if( xobj.apply_to[0]=='user' ) {
				if( m_users_by_id.hasOwnProperty(xid) ) apply_to_text = '<a href="'+htmlspecialchars(mj.uwn,true,true)+'/administration/user_groups#user_id='+encodeURIComponent(xid)+'" target="_blank">'+htmlspecialchars(m_users_by_id[xid][1])+'</a>';
			} else if( xobj.apply_to[0]=='group' ) {
				if( m_groups_by_id.hasOwnProperty(xid) ) apply_to_text = '<a href="'+htmlspecialchars(mj.uwn,true,true)+'/administration/user_groups#group_id='+encodeURIComponent(xid)+'" target="_blank">'+htmlspecialchars(m_groups_by_id[xid].name)+'</a>';
			}
		}
		return apply_to_text;
	}

	function _init() {
		if( m_mbp_colr2h_template===null ) {
			m_mbp_colr2h_template = $(	 '<button class="mbp-action mbp-default" type="button" tabindex="0">'+mjt('mbulk-perms-button-default')+'</button>'
										+'<button class="mbp-action mbp-allow" type="button" tabindex="0">'+mjt('mbulk-perms-button-allow')+'</button>'
										+'<button class="mbp-action mbp-deny" type="button" tabindex="0">'+mjt('mbulk-perms-button-deny')+'</button>' );
		}
		if( m_mbp_cell_template===null ) {
			m_mbp_cell_template = $(  '<button class="mbp-action mbp-default" type="button" tabindex="0">'+mjt('mbulk-perms-button-default')+'</button>'
										+'<div class="mbp-inherit-info"></div>'
										+'<button class="mbp-action mbp-allow" type="button" tabindex="0">'+mjt('mbulk-perms-button-allow')+'</button>'
										+'<button class="mbp-action mbp-deny" type="button" tabindex="0">'+mjt('mbulk-perms-button-deny')+'</button>'
										+'<div class="mbp-explicit-info"></div>' );
		}
	}

	function _setup_bulk_perms_widget_cell( cell, media_id, action, bp ) {
		var mbp_cell = m_mbp_cell_template.clone(),
			mbp_default = mbp_cell.filter('button.mbp-default'),
			mbp_inherit_info = mbp_cell.filter('div.mbp-inherit-info'),
			mbp_allow = mbp_cell.filter('button.mbp-allow'),
			mbp_deny = mbp_cell.filter('button.mbp-deny'),
			mbp_explicit_info = mbp_cell.filter('div.mbp-explicit-info');
		if( bp.hasOwnProperty('inherited') ) {
			var def_text = '';
			if( bp.inherited.allow_deny ) {
				mbp_default.html(mjt('mbulk-perms-button-default-allowed')).addClass('mbp-inherit-allow');
				mbp_inherit_info.addClass('mbp-inherit-allow');
				def_text = mjt('mbulk-perms-def-allowed-by');
			} else {
				mbp_default.html(mjt('mbulk-perms-button-default-denied')).addClass('mbp-inherit-deny');
				mbp_inherit_info.addClass('mbp-inherit-deny');
				def_text = mjt('mbulk-perms-def-denied-by');
			}
			var cat_id = bp.inherited.cat_id||0;
			if( cat_id ) {
				var apply_to_text = _get_apply_to_text(bp.inherited);
				var cat_text = MVTrees.getCompactPathHTML(null,cat_id,'acls');
				mbp_inherit_info.html( def_text.replace('%1',apply_to_text).replace('%2',cat_text) );
			}
		} else {
			mbp_default.html(mjt('mbulk-perms-button-default-none')).addClass('mbp-inherit-none');
			mbp_inherit_info.addClass('mbp-inherit-none');
		}
		if( bp.hasOwnProperty('explicit') ) {
			if( bp.explicit.allow_deny ) {
				mbp_allow.addClass('selected disabled').text(mjt('mbulk-perms-button-allowed','!')).prop('disabled',true);
				mbp_explicit_info.addClass('mbp-explicit-allow selected');
			} else {
				mbp_deny.addClass('selected disabled').text(mjt('mbulk-perms-button-denied','!')).prop('disabled',true);
				mbp_explicit_info.addClass('mbp-explicit-deny selected');
			}
			mbp_explicit_info.html(mjt('mbulk-perms-def-explicit-by').replace('%1',_get_apply_to_text(bp.explicit)));
		} else {
			mbp_default.addClass('selected disabled').prop('disabled',true);
			mbp_inherit_info.addClass('selected');
		}
		cell.html(mbp_cell);
	}

	function _setup_bulk_perms_widget_colr2h( colr2h, action  ) {
		var mbp_cell = m_mbp_colr2h_template.clone();
		colr2h.html(mbp_cell);
	}

	function _load_bulk_perms_for_actions( actions, cb ) {

		var fht_fixed_body = m_dlg.find('div.fht-table-wrapper').children('div.fht-fixed-body'),
			colr2h_cells = fht_fixed_body.children('div.fht-thead').find('th.colr2h'),
			all_cells = fht_fixed_body.children('div.fht-tbody').find('td.cell');

		// clear all related cells..
		for( var a=0; a<actions.length; ++a ) {
			all_cells.filter('.cell-x-'+actions[a]).empty();
		}

		if( m_apply_to_group_id===0 && m_apply_to_user_id===0 ) {

			// user or group not yet selected ...
			if( cb ) cb();

		} else {
			var postdata = 'media_ids='+encodeURIComponent(m_media_ids.join(','))
							+'&actions='+encodeURIComponent(actions.join(','))
							+'&group_id='+encodeURIComponent(m_apply_to_group_id)
							+'&user_id='+encodeURIComponent(m_apply_to_user_id);
			$.postJSON('json/administration/bulk_perms-get', postdata, function(j) {
				if( j ) {
					for( var a=0; a<actions.length; ++a ) {
						var action = actions[a],
							action_bp = j.hasOwnProperty(action) ? j[action] : {},
							all_action_cells = all_cells.filter('.cell-x-'+action);
						_setup_bulk_perms_widget_colr2h(colr2h_cells.filter('.colr2h-'+action),action);
						for( var m=0; m<m_media_ids.length; ++m ) {
							var media_id = m_media_ids[m],
								bp = action_bp.hasOwnProperty(media_id) ? action_bp[media_id] : {},
								cell = all_action_cells.filter('.cell-'+media_id+'-'+action);
							_setup_bulk_perms_widget_cell(cell,media_id,action,bp);
						}
					}
					if( cb ) cb();
				}
			}, true );
		}

	}

	function _is_admin_deny_action( btn_action ) {
		if( btn_action==='deny' ) {
			if( m_apply_to_group_id ) {
				if( m_groups_by_id.hasOwnProperty(m_apply_to_group_id) && arr_inArray('administrator',m_groups_by_id[m_apply_to_group_id].roles)!==-1 ) return true;
			} else if( m_apply_to_user_id ) {
				if( m_users_by_id.hasOwnProperty(m_apply_to_user_id) && arr_inArray('administrator',m_users_by_id[m_apply_to_user_id][3])!==-1 ) return true;
			}
		}
		return false;
	}

	function _load_all_bulk_perms( cb ) {
		var fht_fixed_body = m_dlg.find('div.fht-table-wrapper').children('div.fht-fixed-body'),
			fht_fixed_body_thead = fht_fixed_body.children('div.fht-thead'),
			fht_fixed_body_tbody = fht_fixed_body.children('div.fht-tbody'),
			colr2h_cells = fht_fixed_body_thead.find('th.colr2h').empty(),
			all_cells = fht_fixed_body_tbody.find('td.cell').empty(),
			actions = [];

		fht_fixed_body_thead.scrollLeft(0).scrollTop(0);
		fht_fixed_body_tbody.scrollLeft(0).scrollTop(0);

		for( var i=0; i<m_all_actions.length; ++i ) actions.push(m_all_actions[i].id);
		_load_bulk_perms_for_actions(actions,cb);

		// action column headers event delegation setup ...
		colr2h_cells.off('click').on('click','button',function(e) {
			var self = $(this),
				btn_action = elementHasClassName(this,'mbp-default') ? 'inherit' : ( elementHasClassName(this,'mbp-allow') ? 'allow' : 'deny' ),
				th = self.closest('th.colr2h'),
				action = th.attr('mj_action');
			function _actual_apply_to_column() {
				startProgress(true);
				var postdata = 'action='+encodeURIComponent(action)
								+'&group_id='+encodeURIComponent(m_apply_to_group_id)
								+'&user_id='+encodeURIComponent(m_apply_to_user_id);
				for( var midx=0; midx<m_media_ids.length; ++midx ) postdata += '&rules%5B'+encodeURIComponent(m_media_ids[midx])+'%5D='+btn_action;
				$.postJSON('json/administration/bulk_perms-apply', postdata, function(j) {
					_load_bulk_perms_for_actions( [action], function() {
						stopProgress();
					} );
				}, true );
			}
			if( _is_admin_deny_action(btn_action) ) {
				confirm_box(mjt('mbulkperms-add-admin-deny-confirm-title'),mjt('mbulkperms-add-admin-deny-confirm'),function() {
					_actual_apply_to_column();
				} );
			} else {
				_actual_apply_to_column();
			}
		});

		// cell action event delegation setup ...
		all_cells.off('click').on('click','button',function(e) {
			var self = $(this),
				btn_action = elementHasClassName(this,'mbp-default') ? 'inherit' : ( elementHasClassName(this,'mbp-allow') ? 'allow' : 'deny' ),
				cell = self.closest('td.cell'),
				media_id = cell.attr('mj_media_id'),
				action = cell.attr('mj_action');
			function _actual_apply_to_cell() {
				startProgress(true);
				var postdata = 'action='+encodeURIComponent(action)
								+'&group_id='+encodeURIComponent(m_apply_to_group_id)
								+'&user_id='+encodeURIComponent(m_apply_to_user_id);
				postdata += '&rules%5B'+encodeURIComponent(media_id)+'%5D='+btn_action;
				$.postJSON('json/administration/bulk_perms-apply', postdata, function(j) {
					_load_bulk_perms_for_actions( [action], function() {
						stopProgress();
					} );
				}, true );
			}
			if( _is_admin_deny_action(btn_action) ) {
				confirm_box(mjt('mbulkperms-add-admin-deny-confirm-title'),mjt('mbulkperms-add-admin-deny-confirm'),function() {
					_actual_apply_to_cell();
				} );
			} else {
				_actual_apply_to_cell();
			}
		});

	}


	function _load_actions_groups_and_users( show_all_actions ) {
		startProgress(true);
		$.postJSON('json/administration/bulk_perms-info', 'media_ids='+encodeURIComponent(m_media_ids.join(',')), function(j) {
			if( j ) {
				m_table = $('<table class="xdata"><thead><tr class="r1h"></tr><tr class="r2h"></tr></thead><tbody></tbody></table>').appendTo(m_dlg.find('form'));
				var thead_tr1 = m_table.find('thead').children('tr').first(),
					thead_tr2 = thead_tr1.next('tr'),
					tbody = m_table.find('tbody');
				var i, a, u;

				// build hashes from groups and users ...
				m_groups_by_id = {};
				for( i in j.groups ) {
					if( j.groups.hasOwnProperty(i) ) m_groups_by_id[i] = j.groups[i];
				}
				m_users_by_id = {};
				for( i=0; i<j.users.length; ++i ) {
					u = j.users[i];
					m_users_by_id[u[0]] = u;
				}

				// add column headers
				$('<th class="col1h">'
					+'<label class="line" for="'+m_dlg_id+'-apply-to">'+mjt('mbulkperms-apply-to')+'</label>'
					+'<span id="'+m_dlg_id+'-apply-to-widget" style="display:inline-block"></span>'
					+'<span class="link reload" tabindex="0"></span>'
					+'</th>').appendTo(thead_tr1);

				$('<th class="col1r2h">'+mjt('mbulkperms-for-all-files')+'</th>').appendTo(thead_tr2);

				if( show_all_actions ) m_all_actions = j.system_actions.concat(j.custom_actions);
				else m_all_actions = [ j.system_actions[0] ];

				for( i=0; i<m_all_actions.length; ++i ) {
					a = m_all_actions[i];
					$('<th class="colh"><div class="colh-inner"><span class="colh-text"></span></div></th>')
						.find('.colh-text').text(a.title).end()
						.appendTo(thead_tr1);
					$('<th class="colr2h"></th>')
						.attr('mj_action',a.id)
						.addClass('colr2h-'+a.id)
						.appendTo(thead_tr2);
				}

				// add rows ...
				for( var midx=0; midx<m_media_ids.length; ++midx ) {
					var media_id = m_media_ids[midx],
						row = $('<tr></tr>'),
						meta = j.meta[media_id] || {'-1':[0]},
						title = meta[101]?meta[101][0]:'';
					$('<th class="rowh"><div class="item-thumb"></div></th>')
						.addClass('rowh-'+media_id)
						.appendTo(row)
						.children('.item-thumb')
						.text(media_id)
						.after('<span class="item-id">ID: '+media_id +'<br /></span>'
								+'<span class="item-title">'+htmlspecialchars(title)+'</span>' );
					// + one cell per media item per action
					for( i=0; i<m_all_actions.length; ++i ) {
						a = m_all_actions[i];
						// a.id
						$('<td class="cell"></td>')
							.attr('mj_media_id',media_id)
							.attr('mj_action',a.id)
							.addClass('cell-x-'+a.id)
							.addClass('cell-'+media_id+'-'+a.id)
							.appendTo(row);
					}
					row.appendTo(tbody);
				}

				m_table.fixedHeaderTable( {
					width:				'auto',
					height:				'auto',
					footer:				false,
					cloneHeadToFoot:	false,
					fixedColumns:		1,
					altClass:			'odd',
					borderCollapse:		true,
				} );

				var fht_table_wrapper = m_dlg.find('div.fht-table-wrapper'),
					fht_fixed_body = fht_table_wrapper.children('div.fht-fixed-body'),
					fht_fixed_column = fht_table_wrapper.children('div.fht-fixed-column');

				if( !show_all_actions ) {
					$('<div id="mbp-load-all-actions" class="emph-link mbp-load-all-actions" tabindex="0">'+mjt('mbulkperms-load-all-actions')+'</div>')
						.prependTo( fht_fixed_body.children('div.fht-thead') )
						.click( function() {
							open(m_media_ids,true);
						} );
				}

				// fixup generated html
				var fcthtrows = fht_fixed_column.find('> .fht-thead > table > thead > tr');
				fcthtrows.first().addClass('r1h').next().addClass('r2h');
				fht_fixed_body.children('div.fht-tbody').attr('tabindex','-1');
				fht_fixed_body.find('select,span.reload').remove();

				// update dialog dimensions
				MVPage_trigger_winresize();

				// add & load thumbnails (after fixedHeaderTable was setup..)
				fht_fixed_column.find('div.item-thumb').each( function() {
					MThumbnails.createOnTarget(
						this,
						{
							media_id: $(this).text(),
							width: 100,
							height: 90,
							thumb_loader_anim: true,
						}
					);
				});


				var apply_to_val = null;
				if( m_apply_to_group_id || m_apply_to_user_id ) {
					// select user/group as was used on previous dialog
					apply_to_val = m_apply_to_group_id ? ('group.'+m_apply_to_group_id) : ('user.'+m_apply_to_user_id);
				}

				var _reload = function() {
					startProgress(true);
					_set_apply_to( $('#'+m_dlg_id+'-apply-to').val(), function() {
						_load_all_bulk_perms( function() {
							stopProgress();
						} );
					} );
				};

				// show widget for selecting group or user ...
				var apply_to_widget = $('#'+m_dlg_id+'-apply-to-widget');
				apply_to_widget.mjWidget('destroy').mjWidget(
					{
						type: 'group_or_user',
						id: m_dlg_id+'-apply-to',
						name: 'apply_to',
						show_ids: true,
						value: apply_to_val,
						add_empty_default: true,
						setup_cb: function() {
							$(this).find('.select2-container').css({width:'auto','min-width':'100%','max-width':'100%'});
							_reload();
						},
						change: function() {
							_reload();
						},
						entity_source: {
							// pass response data to widget ( contains what is expected: object j.groups and array j.users (with [id,display-name] each) )
							data: j,
						},
					}
				);
				apply_to_widget
					.next('.reload').click( function() {
						_reload();
						return false;
					} );
				stopProgress();
			}
		}, true );
	}

	function open( media_ids, show_all_actions ) {
		_init();
		_prepare_dlg();
		// save media ids and options for later use
		m_media_ids = media_ids;
		// init other member data
		m_all_actions = [];
		// show dialog
		_setup_and_show_dlg();
		// load list of available actions & groups & users...
		_load_actions_groups_and_users( show_all_actions );
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_bulk_perms',open),
	};
}(jQuery,mj); // namespace MVBulkPermissions
